import { ModalBody, ModalHeader } from 'reactstrap'
import { ICSModal } from '../../components'
import ICSButton from '../../components/ICS/Button/ICSButton'
import { ScrollView } from 'devextreme-react'

const AcceptableUsagePolicy = ({
  policy,
  accept,
  decline
}) => {
  return (
    <ICSModal 
      id="aup_container"
      modalId="aup_modal"
      visible={true}
      onHiding={() => {
        return
      }}
      defaultWidth={800}
      resizeEnabled={true}
      closeOnOutsideClick={false}
      position={{
        of: "window",
        at: "top center",
        collision: "fit",
        boundaryOffset: "0 100"
      }}
    >
    <div className='aup-header-container'>
      <ModalHeader
        className={'ics-modal-header aup-header'}
        id="login_img"
      ></ModalHeader>
    </div>
    <ModalBody className='aup-modal-body'>
      <ScrollView className='aup-text' style={{ whiteSpace: 'pre-wrap', height: '550px'}}>
        {policy}
      </ScrollView>
    </ModalBody>
    <div className='aup-footer'>
      <ICSButton
       id='Acceptable_Usage_Policy_Accept'
       width={60}
       useSubmitBehavior={true}
       type='success'
       onClick={accept}
       className='aup-accept'
     >
       Accept
     </ICSButton>
     <ICSButton
       id='Acceptable_Usage_Policy_Decline'
       width={60}
       useSubmitBehavior={true}
       type='danger'
       onClick={decline}
       className='aup-decline'
     >
       Decline
     </ICSButton>
    </div>
    </ICSModal>
  )
}

export default AcceptableUsagePolicy